import React from 'react'
import NotificationListScreen from '../components/NotificationTemplate/NotificationTable'

const NotificationTemplateScreen = () => {
  return (
    <div>
        <NotificationListScreen/>
    </div>
  )
}

export default NotificationTemplateScreen